import React  from 'react'
import {compose, setDisplayName, withHandlers, withPropsOnChange, withStateHandlers} from "recompose";
import { ifElse, always, equals } from "ramda";
import {connect} from "react-redux";

import { nextDropdown } from '../../../../../../actions/dropdown'
import { DropdownMenu } from "../../../../../Shared/DropdownMenu/DropdownMenu";

import './Appearence.css'
import {getLocaleString} from "../../../../../../locale";

import { not } from "ramda";
import { appearenceTextColor,
  appearenceTextFont } from "../../../../../../actions/reader";
import {fontSizes} from "../../../../../../constants";

const DROPDOWN_ID = 'APPEARENCE'
const isActive = equals(DROPDOWN_ID)

const toggleMenu = ({activeDropdown, nextDropdown}) => ({isInner = false}) => ifElse(
  equals(true),
  () => nextDropdown(null),
  () => ifElse(
    equals(false),
    () => nextDropdown(DROPDOWN_ID),
    always(null)
  )(isInner)
)(isActive(activeDropdown))

const state = {
  sizeSelectOpen: false,
}

const stateHandlers = {
  onOpenSizeSelect: ({ sizeSelectOpen }) => () => ({
    sizeSelectOpen: not(sizeSelectOpen)
  })
}

const mapStateToProps = state => ({
  bookInfo: state.reader.bookInfo,
  activeDropdown: state.activeDropdown,
  size: state.appearence.size,
  color: state.appearence.color,
  font: state.appearence.font,
  flow: state.appearence.flow
})

const mapDispatchToProps = (dispatch) => ({
  nextDropdown: (id) => dispatch(nextDropdown(id)),
  setColor: (color) => dispatch(appearenceTextColor(color)),
  setFont: (font) => dispatch(appearenceTextFont(font))
})

const handlers = withHandlers({
  toggleMenu
})

export const enhance = compose(
  setDisplayName('Appearence'),
  connect(mapStateToProps, mapDispatchToProps),
  withPropsOnChange(['activeDropdown'], ({activeDropdown}) => ({
    active: isActive(activeDropdown)
  })),
  handlers,
  withStateHandlers(state, stateHandlers)
)

const colors = [
  {name: 'white', code: '#fff'},
  {name: 'very_light_pink', code: '#e9e9e9'},
  {name: 'pale', code: '#e9e7db'},
  {name: 'black', code: '#000'}
]
const fonts = ['inherit', 'Noto Sans', 'Roboto', 'Arial', 'PT Sans', 'PT Serif', 'Lato', 'Open Sans']

const TextSize = ({ onChangeTextSize, size, sizeSelectOpen, onOpenSizeSelect }) => (
  <div className="TextSize">
    <span className="TextSize__title">{getLocaleString('reader.textSize')}:</span>
    <div className="TextSize__select" onClick={() => onOpenSizeSelect()}>
      <span className="TextSize__select-value">{size}</span>
      <i className="select-arrow"></i>
      <div className={`TextSize__list${sizeSelectOpen ? ' show' : ''}`}>
        {fontSizes.map((size, index) => (
          <span key={index} className="TextSize__list-item" data-value={size}
              onClick={(e) => {e.stopPropagation();onOpenSizeSelect();
              onChangeTextSize(e.target.dataset.value)}}>{size}</span>
        ))}
      </div>
    </div>
    <div className="TextSize__zoom">
      <button className={`Zoom_out icon-btn${fontSizes[0] === parseInt(size, 10) ? ' disable' : ''}`} onClick={e => {e.stopPropagation();onChangeTextSize(false)}}></button>
      <button className={`Zoom_in icon-btn${fontSizes[fontSizes.length-1] === parseInt(size, 10) ? ' disable' : ''}`} onClick={e => {e.stopPropagation();onChangeTextSize(true)}}></button>
    </div>
  </div>
)

const TextColor = ({ onChangeTextColor, setColor, selectedColor, format }) => (
  <div className="TextColor">
    <span className="TextColor__title">{getLocaleString('reader.textColor')}:</span>
    <div id="TextColor">
      {colors.map((color, index) => (
        format === 'pdf' && (index === 1 || index === 2) ? '' : <span key={index} className={`color ${color.name} ${selectedColor === color.name ? 'checked' : ''}`}
              onClick={() => {setColor(color.name); onChangeTextColor(color.name)}}></span>
      ))}
    </div>
  </div>
)

const TextFont = ({ onChangeTextFont, onChangeFont, selectedFont }) => (
  <div id="TextFont" className="TextFont">
    {fonts.map((font, index) => (
      <FontItem font={font} isDefault={false} index={index} key={index} selectedFont={selectedFont} onChangeFont={onChangeFont} onChangeTextFont={onChangeTextFont}/>
    ))}
  </div>
)

const FontItem = ({index, font, selectedFont, onChangeFont, onChangeTextFont}) => (
  <span className={`font${selectedFont === font ? ' checked' : ''}`} onClick={() => {onChangeFont(font); onChangeTextFont(font)}}>
        <i className="icon-radio"></i>
    {index === 0 ? getLocaleString('reader.default') : font}
  </span>
)

const Zoom = ({onZoom, scale, flow}) => (
  <div className="Zoom">
    <span className="Zoom__title">{getLocaleString('reader.zoom')}:</span>
    <div className="Zoom_btns">
      <button className={`Zoom_out icon-btn${Math.round(100 - (1 - scale)*100) === 60 ? ' disable' : ''}`} onClick={() => onZoom(true)}></button>
      <button className={`Zoom_in icon-btn${Math.round(100 - (1 - scale)*100) === 200 ? ' disable' : ''}`} onClick={() => onZoom(false)}></button>
    </div>
    <span className="Zoom_value">{Math.round(100 - (1 - scale)*100)}%</span>
  </div>
)

const View = ({toggleMenu, active, onChangeTextSize, onChangeTextColor,
                sizeSelectOpen, onOpenSizeSelect, onChangeTextFont, size,
                setColor, color, setFont, font, flow, bookInfo, onZoom, scale }) => (
  <div className="Appearence">
    <button className="appearence-btn icon-btn" onClick={toggleMenu} data-active={active}></button>
    <DropdownMenu active={active}>
      <div className="Appearence__header Dropdown__header">
        <span className="Appearence__header-text">{getLocaleString('reader.appearenceTitle')}</span>
        <button className="btn btn-close-white icon-btn" onClick={toggleMenu} data-active={active}></button>
      </div>
      {bookInfo.format !== 'pdf' ?
        <TextSize onChangeTextSize={onChangeTextSize} size={size}
                  sizeSelectOpen={sizeSelectOpen} onOpenSizeSelect={onOpenSizeSelect}/>
      : ''}
      {bookInfo.format === 'pdf' ?
        <Zoom onZoom={onZoom} scale={scale} flow={flow}/>
        : ''}
      <TextColor onChangeTextColor={onChangeTextColor} setColor={setColor} selectedColor={color} format={bookInfo.format}/>
      {bookInfo.format !== 'pdf' ?
        <TextFont onChangeTextFont={onChangeTextFont} onChangeFont={setFont} selectedFont={font}/>
      : ''}
    </DropdownMenu>
  </div>
)

export const Appearence = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Reader/components/Navigation/components/Appearence/Appearence.js